<template>
  <div>
    <v-flex  v-if="isLoading" xs12 pa-2 class="text-xs-center">
      <v-progress-circular :size="48" :width="5" color="primary" indeterminate></v-progress-circular>
    </v-flex>
    <v-data-table
        style="width: 100%"
        v-if="!isLoading"
        :headers="headers"
        :items="checkLists"
        :options.sync="pagination"
        :server-items-length="serverItemsLength"
    >
      <template v-slot:item="props">
        <tr>
          <td style="width: 7%">{{ props.item.driver.id }}</td>
          <td style="width: 7%">{{ props.item.taxi.id }}</td>
          <td style="width: 7%">{{ props.item.taxi.registration_number }}</td>
          <td style="width: 7%">{{ Boolean(props.item.road_tax) }}</td>
          <td style="width: 7%">{{ Boolean(props.item.wipers) }}</td>
          <td style="width: 7%">{{ Boolean(props.item.mirrors) }}</td>
          <td style="width: 7%">{{ Boolean(props.item.fuel_level) }}</td>
          <td style="width: 7%">{{ Boolean(props.item.fluid_level) }}</td>
          <td style="width: 7%">{{ Boolean(props.item.brakes) }}</td>
          <td style="width: 7%">{{ Boolean(props.item.battery) }}</td>
          <td style="width: 7%">{{ Boolean(props.item.seat_belt) }}</td>
          <td style="width: 7%">{{ Boolean(props.item.belts_and_hoses) }}</td>
          <td style="width: 7%">{{ Boolean(props.item.leaks) }}</td>
          <td style="width: 7%">{{ Boolean(props.item.horn) }}</td>
          <td style="width: 7%">{{ Boolean(props.item.mot) }}</td>
          <td style="width: 7%">{{ Boolean(props.item.light) }}</td>
          <td style="width: 7%">{{ Boolean(props.item.taxi_plate) }}</td>
          <td style="width: 7%">{{ Boolean(props.item.dashborad_warning_lights) }}</td>
          <td style="width: 7%">{{ Boolean(props.item.emergency_kit) }}</td>
          <td style="width: 7%">{{ Boolean(props.item.tires) }}</td>
          <td style="width: 7%">{{ getReadableTime(props.item.verified_at) }}</td>

<!--          <td style="width: 25%">
            <v-row>
              <v-btn
                  v-if="
                  props.item.state == 'completed' ||
                  props.item.state == 'rejected'
                "
                  @click="resendReminder(props.item.driver.id)"
                  x-small
                  style="">
                Resend Reminder
              </v-btn>
              <v-btn
                  v-if="props.item.state == 'pending'
                  || props.item.state == 'completed'
                  || props.item.state == 'rejected'"
                  @click="viewDoc(props.item)"
                  x-small
                  style="">
                View Document
              </v-btn>
              <v-btn @click="viewDocument(props.item)" x-small style="">
                Upload Document
              </v-btn>
            </v-row>
          </td>

          <td
              v-if="props.item.state == 'requires_verification'"
              style="width: 5%"
          ></td>-->

        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import {replaceStart} from "@/components/util/PhoneNumbers.js";
import axios from "axios";
import AttributesForTaxiCell from "@/components/widget/AttributesForTaxiCell.vue";
import FileInput from "@/components/widget/input/FileInput.vue";

axios.defaults.withCredentials = true;

export default {
  name: "driver_documents_list",
  components: {
    AttributesForTaxiCell,
    FileInput,
  },
  props: {
    query: Object,
  },
  data: function () {
    return {
      uploadedFile: null,
      fetchedDriverDocumentURL: null,
      fetchedDriverDocument: null,
      dateForNewDocument: new Date().toISOString().substr(0, 10),
      serverItemsLength: null,
      selectedItem: null,
      viewFileDialog: false,
      rideTypes: [],
      pagination: {},
      headers: [
        {
          text: "Driver ID",
          align: "left",
          sortable: false,
          value: "id",
        },
        {
          text: "Taxi ID",
          align: "left",
          sortable: false,
          value: "id",
        },
        {
          text: "Registration Number",
          align: "left",
          sortable: false,
          value: "registration_number",
        },
        {
          text: "Road Tax",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "Wipers",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "Mirrors",
          align: "left",
          sortable: false,
          value: "document",
        },

        {
          text: "Fuel Level",
          align: "left",
          sortable: false,
          value: "contact_number",
        },
        {
          text: "Fluid Level",
          align: "left",
          sortable: false,
          value: "document",
        },
        {
          text: "Brakes",
          align: "left",
          sortable: false,
          value: "taxi",
        },
        {
          text: "Battery",
          align: "left",
          sortable: false,
          value: "taxi",
        },
        {
          text: "Seat Belt",
          align: "left",
          sortable: false,
          value: "taxi",
        },
        {
          text: "Belts and Hoses",
          align: "left",
          sortable: false,
          value: "taxi",
        },
        {
          text: "Leaks",
          align: "left",
          sortable: false,
          value: "taxi",
        },
        {
          text: "Horn",
          align: "left",
          sortable: false,
          value: "taxi",
        },
        {
          text: "MOT",
          align: "left",
          sortable: false,
          value: "taxi",
        },
        {
          text: "Light",
          align: "left",
          sortable: false,
          value: "taxi",
        },
        {
          text: "Taxi Plate",
          align: "left",
          sortable: false,
          value: "taxi",
        },
        {
          text: "Dashboard Warning Lights",
          align: "left",
          sortable: false,
          value: "taxi",
        },
        {
          text: "Emergency Kit",
          align: "left",
          sortable: false,
          value: "taxi",
        },
        {
          text: "Tires",
          align: "left",
          sortable: false,
          value: "taxi",
        },
        {
          text: "Verified At",
          align: "left",
          sortable: false,
          value: "taxi",
        },
      ],
      checkLists: [],
      isLoading: true,
    };
  },
  mounted: async function () {
    console.log("MOUNTED");
    await this.getTaxiChecklists();
  },
  watch: {
    pagination: {
      handler() {
        this.getTaxiChecklists();
      },
      deep: true,
    },
  },
  methods: {
    refresh() {
      console.log("Refresh Docs");
      this.getTaxiChecklists();
    },
    clearAndRefresh() {
      console.log("boom");

      this.pagination.page = 1;
      this.getTaxiChecklists();
    },
    formatNumber: function (number) {
      return replaceStart(number);
    },
    getTaxiChecklists: async function () {
      // this.isLoading = true;
      console.log("Get Photo Entries");

      const {page, itemsPerPage} = this.pagination;

      console.log("Pagination " + JSON.stringify(this.pagination));

      try {
        var url = `${
            this.$store.state.apiUrl
        }/taxi_checklist/list?offset=${
            itemsPerPage * (page - 1)
        }&count=${itemsPerPage}&filter=${this.query.filter}`;

        console.log(url);

        let response = await axios.get(url, {
          params: {},
        });

        this.checkLists = response.data.taxi_checklist;

        this.serverItemsLength = response.data.pages.total;

      } catch (error) {
        console.log("Failed to get photos " + error);
      } finally {
        this.isLoading = false;
      }

      console.log("isLoading: ", this.isLoading);
    },
    getReadableTime: function (time) {
      return new Date(time).toLocaleString();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

table.v-table tbody tr td {
  height: 19px;
  padding: 2px 3px !important;
}

thead th:not(:first-child) {
  padding: 0 4px;
}

.fixed-booking-table-row {
  overflow: hidden;
  height: 18px;
}
</style>
